import React, { Fragment, useCallback, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  NavLink,
  NavLinkProps,
  RouteComponentProps,
  withRouter,
} from "react-router-dom";

import {
  faFileInvoiceDollar,
  faTachometerFast,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { route } from "@/configs/route.configs";
import { logOut } from "@/reducers/mrgReducer/mrgThunks";
import { isNotSet, isSet } from "@/tools/format.checker";

import GroupSelectModal from "@/components/Feature/GroupSelectModal/GroupSelectModal";
import ConditionalFragment from "@/components/General/ConditionalFragment";
import { useUserProfileContext } from "@/context/UserProfileContext";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faStore } from "@fortawesome/pro-duotone-svg-icons";
import LogOutConfirm from "./LogOutConfirm";

type ReduxProps = ConnectedProps<typeof connector>;

type OwnProps = {};

type Props = ReduxProps & OwnProps & RouteComponentProps;

const Drawer: React.FC<Props> = ({ logOut, history }) => {
  const [checked, setChecked] = useState<boolean>(false);
  const [logOutClick, setLogOutClick] = useState<boolean>(false);
  const [showGroupSelectModal, setShowGroupSelectModal] =
    useState<boolean>(false);
  const { group, name, email } = useUserProfileContext();
  const groupImg = group?.logoPhotoFile?.url;

  const navItemsRef = useRef<
    Array<
      Omit<NavLinkProps, "className" | "activeClassName"> & { icon: IconProp }
    >
  >([
    {
      to: route.dashboard.to(),
      children: "主控台",
      exact: true,
      icon: faTachometerFast,
    },
    // {
    //   to: route.plan.to(),
    //   children: "方案與付款管理",
    //   icon: faScroll,
    // },
    // {
    //   to: route.point.path,
    //   children: "夯幣管理",
    //   icon: faCoinBlank,
    // },
    // {
    //   to: route.manager.path,
    //   children: "管理員管理",
    //   icon: faUserGear,
    // },
    // {
    //   to: route.invite.to(),
    //   children: "邀請碼管理",
    //   icon: faUserFriends,
    // },
    {
      to: route.salaryManagement.path,
      children: "業績分潤計算",
      icon: faFileInvoiceDollar,
    },
    // {
    //   to: route.paymentIntegration.to(),
    //   children: "金流串接",
    //   icon: faCircleDollarToSlot,
    // },
    // {
    //   to: route.download.to(),
    //   children: "APP下載",
    //   icon: faDownload,
    // },
  ]);
  const onLogoutClick = () => {
    logOut();
    history.push(route.login.to());
  };

  const triggerDrawerChecked = useCallback(
    () => setChecked((prev) => !prev),
    []
  );

  const toggleShowModal = useCallback(() => {
    setShowGroupSelectModal((prev) => !prev);
  }, []);

  return (
    <Fragment>
      <ConditionalFragment condition={showGroupSelectModal}>
        <GroupSelectModal onClose={toggleShowModal} showCloseButton />
      </ConditionalFragment>
      {logOutClick && (
        <LogOutConfirm
          close={() => setLogOutClick(false)}
          logOut={onLogoutClick}
        />
      )}
      <input
        id="drawer__checkbox"
        onChange={triggerDrawerChecked}
        className="drawer__checkbox--checkbox"
        type="checkbox"
        checked={checked}
      />
      <label htmlFor="drawer__checkbox" className="drawer__checkbox--icon" />
      <nav className={`drawer`}>
        <span className="drawer__img flex-shrink-0">
          <ConditionalFragment condition={isSet(groupImg)}>
            <img src={groupImg} alt="Group" className={"h-full"} />
          </ConditionalFragment>
          <ConditionalFragment condition={isNotSet(groupImg)}>
            <span className="drawer__img--icon">
              <FontAwesomeIcon icon={faStore} />
            </span>
          </ConditionalFragment>
        </span>
        <span className={"drawer__name px-4 w-full flex-shrink-0"}>
          {group?.name ?? ""}
        </span>
        <button
          onClick={() => {
            toggleShowModal();
            setChecked(false);
          }}
          className="btn btn__switch drawer__btn"
        >
          <span className="drawer__btn--icon">
            <FontAwesomeIcon icon={["far", "exchange-alt"]} />
          </span>
          切換品牌
        </button>
        <ul className="drawer__list">
          {navItemsRef.current.map((props, index) => (
            <HungerNavItem
              key={index}
              {...props}
              onClick={triggerDrawerChecked}
            />
          ))}
          <li>
            <button
              className="drawer__item"
              onClick={() => setLogOutClick(true)}
            >
              <span className="drawer__item--icon">
                <FontAwesomeIcon icon={["far", "sign-out"]} />
              </span>
              登出
            </button>
          </li>
        </ul>
        <div className="drawer__user">
          <span className="drawer__user--icon">
            <FontAwesomeIcon icon={["far", "user"]} />
          </span>
          <span className="drawer__user--content">
            <span className="drawer__user--name tiny">{name}</span>
            <span className="drawer__user--email tiny">{email}</span>
          </span>
        </div>
      </nav>
    </Fragment>
  );
};

const mapDispatchToProps = { logOut };

const connector = connect(null, mapDispatchToProps);

export default connector(withRouter(Drawer));

const HungerNavItem: React.FC<
  Omit<NavLinkProps, "className" | "activeClassName"> & { icon: IconProp }
> = ({ icon, children, ...props }) => {
  return (
    <li>
      <NavLink
        className="drawer__item"
        activeClassName="drawer__item--active"
        {...props}
      >
        <span className="drawer__item--icon">
          <FontAwesomeIcon icon={icon} />
        </span>
        {children}
      </NavLink>
    </li>
  );
};
